export const POST_GET_ALL = 'POST_GET_ALL'
export const POST_GET_ONE = 'POST_GET_ONE'
export const POST_ERROR = 'POST_ERROR'
export const POST_DELETE = 'POST_DELETE'
export const POST_UPDATE_LIKE = 'POST_UPDATE_LIKE'
export const POST_CREATE = 'POST_CREATE'
export const POST_ADD_COMMENT = 'POST_ADD_COMMENT'
export const POST_REMOVE_COMMENT = 'POST_REMOVE_COMMENT'
export const POST_CLEAR = 'POST_CLEAR'
